import { Component, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import {
    IonicPage, NavController, NavParams, LoadingController, Loading, ToastController,
    Content, Platform, AlertController, PopoverController, Events, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Page } from '../../enums/page.enum';
import { FormControl } from '@angular/forms';

/* Models */
import { CustomerModel } from '../../models/customer/customer.model';
import { ProductModel } from '../../models/product/product.model';
import { LineTypeModel } from '../../models/product/linetype.model';
import { OrderHeaderModel } from '../../models/order/orderheader.model';
import { OrderDetailModel } from '../../models/order/orderdetail.model';
import { OrderHighLevelModel } from '../../models/order/orderhighlevel.model';
import { Errors } from '../../services/apperror';
/* Pages & Popovers */
// import { ProductFilterPopover } from '../popover/product-filter-popover/product-filter-popover';
/* Filters & Services */
import { NumFormatter } from '../../filters/num-formatter.pipe';
// import { PrdFilter } from '../../filters/prdFilter.pipe';
import { ProductService } from '../../services/product.service';
import { UserService } from '../../services/user.service';
import { TransactionService } from '../../services/transaction.service';
import { UtilService } from '../../services/util.service';
import { BadgeService } from '../../services/badge.service';
import { StorageService } from '../../services/storage.service';
import { Setups } from '../../services/setup';
/* lodash */
import * as _ from "lodash";
import { CustomerService } from '../../services/customer.service';
import { ModalAction } from '../../enums/modalaction.enum';
import { BomProductModel } from '../../models/product/bomproduct.model';
import { ProductType } from '../../enums/producttype.enum';
import { SettingId } from '../../enums/settingid.enum';
import { SalesInd } from '../../enums/salesind.enum';
import { AuthWrapper } from '../../infra/authWrapper';
import { CustomerMOVSurchargeModel } from '../../models/customer/customerMOVSurcharge.model';
import { CustomerCrmModel } from '../../models/customer/customercrm.model';

@IonicPage()
@Component({
    selector: 'product',
    templateUrl: 'product.html',
    providers: [NumFormatter]
})
export class Product {
    @ViewChild('foot') elementView: ElementRef;
    @ViewChild(Content) content: Content;
    term = new FormControl();

    // customer: CustomerModel;
    productList: ProductModel[] = [];
    defaultProductList: ProductModel[] = [];
    lineTypeList: LineTypeModel[] = [];
    FOCLineTypeList: LineTypeModel[] = [];
    RebateLineTypeList: LineTypeModel[] = [];
    oriProductList: ProductModel[] = [];
    oriPageIndex: number = 0;
    hideCustomerDetail: Boolean = true;
    addQtyList: ProductModel[] = [];
    loading: Loading;
    bottomPixel: string;
    direction: string = 'up';
    pageIndex: number = 0;
    showScrollToTop: Boolean = false;
    showCustomer: Boolean = false;
    searchTerm: string = "";
    selectedCustomer: CustomerModel = <CustomerModel>{};
    selectedPrevCustomer: CustomerModel = <CustomerModel>{};
    salesInd: string = 'S'; // Sales = S, FOC = F
    order: OrderHeaderModel = <OrderHeaderModel>{};
    isFirstLoad: Boolean = true;
    prdGrpCode: string = "";
    prdSubGrpCode: string = "";
    prdShowBonus: string = "";
    prdShowMustSell: string = "";
    isValidCustomer : Boolean = true;
    isVN: Boolean = false;
    isShowingBaseUOM: Boolean = false;
    // CCLIORDER-2818
    // TODO: HK SAP implementation
    isShowingMOV: boolean = false;
    customerMOVSurcharge: CustomerMOVSurchargeModel = new CustomerMOVSurchargeModel;
    // CCLIORDER-2818
    public ProductTypeEnum = ProductType;
    public SettingIdEnum = SettingId;
    public SalesIndEnum = SalesInd;
    isShowingCustomerCrm: boolean = false;
    customerCrmContent: string = '';
    isShowingExpireDate: boolean = false;
    material_group_4:string="";
    isShowingVisaExpiryDate: boolean = false; //EO-3457 - VN Display VISA and Batch

    constructor(private storage: Storage
        , public myElement: ElementRef
        , private platform: Platform
        , public navParams: NavParams
        , private events: Events
        , private changeDetectorRef: ChangeDetectorRef
        , public navCtrl: NavController
        , private loadingCtrl: LoadingController
        , public toastCtrl: ToastController
        , public popoverCtrl: PopoverController
        , public alertCtrl: AlertController
        , private transactionService: TransactionService
        , private productService: ProductService
        , private badgeService: BadgeService
        , public util: UtilService
        , public storageService: StorageService
        , public customerService: CustomerService
        , public setups: Setups
        , public modalCtrl: ModalController
        , private authWrapper: AuthWrapper
        , private userService: UserService
    ) {
        this.isVN = this.util.isRemoveDKSHLogoForVN();
    }

    ngOnInit() {
        if (!this.authWrapper.isAuthenticated()) {
        this.authWrapper.unAuthenticatedRedirect();
        return;
        }
    }

    searchProduct() {
        this.retrieveProductList();
    }

    get isContractOrder(): boolean {
        return !!(this.selectedCustomer && this.selectedCustomer.is_contract_customer && this.selectedCustomer.selected_contract);
    }

    changeContract() {
        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading contract list");
        this.customerService.retrieveCustomerContractList(
            this.selectedCustomer.cust_code
            , this.selectedCustomer.salesorg.shipto_list[0].code
            , this.selectedCustomer.salesorg.salesorg
            , this.selectedCustomer.salesorg.distchannel
            , this.selectedCustomer.salesorg.division
            , this.storageService.getSettingId()
        ).subscribe(
            (res) => {
                this.loading.dismiss();
                let contractModal = this.modalCtrl.create('ContractSelection',
                    { contractList: res.data || [], selectedContract: this.selectedCustomer.selected_contract },
                    { enableBackdropDismiss: false }
                );
                contractModal.onDidDismiss((data) => {
                    if (!data || data.action != ModalAction.Proceed || !data.contract
                        || data.contract.contract_no == this.selectedCustomer.selected_contract.contract_no) {
                        return;
                    }
                    this.selectedCustomer.selected_contract = data.contract;
                    // Cart keeps its contract until user adds a product from the new one
                    if (this.order && this.order.detail && this.order.detail.length == 0) {
                        this.order.contract_no = data.contract.contract_no;
                        this.storageService.setOrder(this.order);
                    }
                    this.storage.set('selectedCustomer', this.selectedCustomer).then(() => {
                        this.retrieveProductList();
                    });
                });
                contractModal.present();
            }, (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
            }
        );
    }


  /**
  * Returns products whose sales qty (cart + new) exceeds contract remain_qty. Skips products without contract target.
  */
    getExceededContractProducts(newItems: ProductModel[]): ProductModel[] {
      if (!this.isContractOrder) return [];

      let cartDetail = (this.order && this.order.detail) ? this.order.detail : [];
      return _.uniqBy(newItems.filter((p) => p.target_qty > 0 && p.line_type && p.line_type.sales_ind == 1), 'prd_code')
        .filter((p) => {
          let cartQty = _.sumBy(cartDetail.filter((d) => d.prd_code == p.prd_code && d.line_type && d.line_type.sales_ind == 1), (d) => Number(d.quantity) || 0);
          let newQty = _.sumBy(newItems.filter((n) => n.prd_code == p.prd_code && n.line_type && n.line_type.sales_ind == 1), (n) => Number(n.quantity) || 0);
          return cartQty + newQty > Number(p.remain_qty);
        });
    }

    displayExceededContractAlert(products: ProductModel[]) {
      let message = products.map((p) => p.prd_code + " - " + p.prd_name + " (remaining: " + p.remain_qty + ")").join("<br>");
      this.util.displayAlert(this.alertCtrl, "Exceeded contract quantity", message);
    }

    /**
     * Cart can only hold products of one contract. Resolves false when user keeps the existing cart.
     */
    confirmContractCart(): Promise<boolean> {
        if (!this.isContractOrder || _.isEmpty(this.order)) {
            return Promise.resolve(true);
        }

        let selectedContractNo = this.selectedCustomer.selected_contract.contract_no;
        if (this.order.detail.length == 0 || !this.order.contract_no || this.order.contract_no == selectedContractNo) {
            this.order.contract_no = selectedContractNo;
            return Promise.resolve(true);
        }

        return new Promise<boolean>((resolve) => {
            let arrButtons = [
                { text: 'Cancel', role: 'cancel', handler: () => { resolve(false); } },
                {
                    text: 'Confirm', handler: () => {
                        this.order.detail = [];
                        this.order.contract_no = selectedContractNo;
                        this.badgeService.resetBadge();
                        resolve(true);
                    }
                }
            ];
            this.util.displayConfirmation(this.alertCtrl, "Change contract",
                "Your order contains products of contract " + this.order.contract_no
                + ". Do you want to clear the current order and add products of contract " + selectedContractNo + "?", arrButtons);
        });
    }

    async ionViewWillEnter() {
        if (!this.authWrapper.isAuthenticated()) {
            this.authWrapper.unAuthenticatedRedirect();
            return;
        }
        this.isShowingBaseUOM = this.storageService.getSetupValue(this.setups.ShowBaseUOM.ID) === "1" ? true : false;
        this.isShowingExpireDate = (this.storageService.getSettingId() === this.SettingIdEnum.MY || this.storageService.getSettingId() === this.SettingIdEnum.VN);
        this.salesInd = this.storageService.getSalesInd();       
        this.selectedCustomer = await this.storage.get('selectedCustomer');
        this.isShowingVisaExpiryDate = this.storageService.getSettingId() === this.SettingIdEnum.VN; // EO-3457 - VN Display VISA and Batc

        // CCLIORDER-2818
        // TODO: HK SAP implementation
        if (this.userService.isHKSurchargeApplicable()) {
            this.isShowingMOV = this.userService.isHKSurchargeApplicable();
            this.customerService.getCustomerMOVSurcharge(this.selectedCustomer.salesorg.salesorg, this.storageService.getSettingId()).subscribe(
                (res) => {
                    this.customerMOVSurcharge = res.data;
                }, (error) => {
                    const errObj = JSON.parse(error._body)
                    // display error
                    this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
                }
            );
        }

        if(this.salesInd=="C" && this.selectedCustomer.order_reason==""){
            let orderreason= await this.storage.get("orderReason")
            this.selectedCustomer.order_reason= orderreason;
        }

        if (this.customerService.isShowingCustomerCrm(this.storageService.getSettingId())) {
            this.customerService.getCustomerCrm(
                this.selectedCustomer.salesorg.salesorg
                , this.selectedCustomer.salesorg.distchannel
                , this.selectedCustomer.salesorg.division
                , this.selectedCustomer.cust_code, this.storageService.getSettingId()
            ).subscribe(
                (res) => {
                    if (res.status === "404") {
                        this.isShowingCustomerCrm = false;
                    } else {
                        this.isShowingCustomerCrm = true;
                        this.customerCrmContent = res.data;

                        this.storage.get("order").then(
                            (value) => {
                                // In case browsing and no order txn_no generated
                                if (value && _.isEmpty(value.txn_no)) {
                                    let _data = new CustomerCrmModel();
                                    _data.CrmTxt = this.customerCrmContent;
                                    _data.CustomerCode = this.selectedCustomer.cust_code;
                                    _data.CustomerName = this.selectedCustomer.cust_name;
                                    _data.SalesOrg = this.selectedCustomer.salesorg.salesorg;
                                    _data.DistChannel = this.selectedCustomer.salesorg.distchannel;
                                    _data.Division = this.selectedCustomer.salesorg.division;

                                    let CustomerCrmPage = this.modalCtrl.create('CustomerCrmPage', { data: _data }, { enableBackdropDismiss: false });
                                    CustomerCrmPage.present();
                                }
                            }
                        );
                    }
                }, (err) => {
                    this.isShowingCustomerCrm = false;
                    const errObj = JSON.parse(err._body);
                    this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
                }
            );
        }
       
        if (this.selectedCustomer) {
            this.showCustomer = (!_.isEmpty(this.selectedCustomer) ? true : false);
            this.order = await this.storage.get('order');         
            if (this.order) {
                let hasChange: boolean = false;
                // CCLIORDER-1556 STARTS
                //[TIC0942234] Error still repeating if you switch salesorg
                if (this.order.salesorg !== this.selectedCustomer.salesorg.salesorg) {
                    this.order.salesorg = this.selectedCustomer.salesorg.salesorg;
                    hasChange = true;
                }
                if (this.order.distchannel !== this.selectedCustomer.salesorg.distchannel) {
                    this.order.distchannel = this.selectedCustomer.salesorg.distchannel;
                    hasChange = true;
                }
                if (this.order.division !== this.selectedCustomer.salesorg.division) {
                    this.order.division = this.selectedCustomer.salesorg.division;
                    hasChange = true;
                }
                if (this.selectedCustomer.salesorg.partial_dlvy_flag === 'X') {
                    this.order.partial_delivery = 'Y';
                    hasChange = true;
                }

                //CCLIORDER-1532- wrong payment term when switch from consignment to normal order
                if (this.order.pay_term_code !== this.selectedCustomer.pay_term_code) {
                    this.order.pay_term_code = this.selectedCustomer.pay_term_code;
                    hasChange = true;
                }
                if (this.order.pay_term_name !== this.selectedCustomer.pay_term_name) {
                    this.order.pay_term_name = this.selectedCustomer.pay_term_name;
                    hasChange = true;
                }

                if (this.order.order_reason !== this.selectedCustomer.order_reason) {
                    this.order.order_reason = this.selectedCustomer.order_reason;
                    hasChange = true;
                }

                if (this.isContractOrder && this.order.detail.length == 0
                    && this.order.contract_no !== this.selectedCustomer.selected_contract.contract_no) {
                    this.order.contract_no = this.selectedCustomer.selected_contract.contract_no;
                    hasChange = true;
                }

                if (hasChange) {
                    await this.storageService.setOrder(this.order);
                }
                // CCLIORDER-1556 ENDS

                let shipto_code: string = this.selectedCustomer.salesorg.shipto_list[0].code,
                    soldto_code: string = this.selectedCustomer.cust_code;
                if (_.isEmpty(this.order))
                    this.createNewOrder();
                else if (this.order.shipto_code != shipto_code || this.order.soldto_code != soldto_code)
                    this.createNewOrder();
            } else {
                this.createNewOrder();
            }

            this.storageService.setFromSession().then(() => {
                if (this.searchTerm != "") {
                    this.retrieveProductList(undefined, this.searchTerm);
                }
                else {
                    this.retrieveProductList();
                }

                this.populateBottomPixel();
                this.navParams.data.refresh = false;
            });
            
        } else {
            // CCLIORDER-1609
            this.util.displayAlert(this.alertCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message);
        }
    }
    
    ionViewWillLeave() {
        this.order = <OrderHeaderModel>{};
    }

    createNewOrder() {
        this.order = this.util.createNewOrder(this.selectedCustomer, this.storageService.getSalesrepCode(), this.storageService.getOrderType(this.storageService.getSalesInd()));
        if (this.isContractOrder) {
            this.order.contract_no = this.selectedCustomer.selected_contract.contract_no;
        }
        this.storageService.setOrder(this.order);
    }

    updatePrdUom(ev, p: ProductModel) {
        let salesorg: string = "",
            division: string = "",
            distchannel: string = "",
            soldto_code: string = "",
            shipto_code: string = "";

        if (!_.isEmpty(this.selectedCustomer)) {
            salesorg = this.selectedCustomer.salesorg.salesorg,
            division = this.selectedCustomer.salesorg.division,
            distchannel = this.selectedCustomer.salesorg.distchannel;
            soldto_code = this.selectedCustomer.cust_code;
            shipto_code = this.selectedCustomer.salesorg.shipto_list[0].code;
        } else {
            p.price = 0;
            return;
        }

        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Updating product price");
        this.productService.retrieveProductPrice(p.prd_code, p.uom, shipto_code, soldto_code, salesorg, division, distchannel, this.storageService.getSettingId(), this.storageService.getOrderType(this.storageService.getSalesInd())).subscribe(
            (data) => {
                if (data) {
                    p.price = data;
                }
            }, (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
            },
            () => {
                this.loading.dismiss();
            });
    }

    /* Scroll */
    loadProductOnScroll(infiniteScroll) {
        this.retrieveProductList(infiniteScroll);
    }

    /* Button Events */
    proceedToOrderPage() {
        // CCLIORDER-1609
        if (_.isEmpty(this.selectedCustomer) || _.isEmpty(this.selectedCustomer.cust_code)) {
            this.util.displayAlert(this.alertCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message);
            return;
        }

        this.customerService.validateSelectedCustomer(this.selectedCustomer.cust_code, this.storageService.getSalesInd(), this.selectedCustomer.order_reason, this.storageService.getSalesrepCode(), this.storageService.getSettingId())
            .subscribe(
                (data) => {
                    if (data.length > 0) {
                        this.storageService.setOrder(this.order).then(() => {
                            this.events.publish('update-order-detail', "start", this.storageService.getToken());
                        });
                        this.navCtrl.parent.select(Page.OrderList);
                    }
                });
    }

    addAllToOrder() {
        // CCLIORDER-1609
        if (_.isEmpty(this.selectedCustomer) || _.isEmpty(this.selectedCustomer.cust_code)) {
            this.util.displayAlert(this.alertCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message);
            return;
        }

        this.customerService.validateSelectedCustomer(this.selectedCustomer.cust_code, this.storageService.getSalesInd(), this.selectedCustomer.order_reason, this.storageService.getSalesrepCode(), this.storageService.getSettingId())
            .subscribe(
                async (data) => {
                    if (data.length > 0) {
                        // EO-3513 - Exclude Freight Fee SKU from bulk "Add All"
                        let arrPrdWithQty = this.productList.filter((r) => {
                            return Number(r.quantity) > 0 && !this.util.isFreightFeeSku(r.prd_code, this.storageService.getSettingId());
                        });
                        if (arrPrdWithQty.length > 0) {
                            if (!(await this.confirmContractCart())) return;
                            let exceededPrdList = this.getExceededContractProducts(arrPrdWithQty);
                            if (exceededPrdList.length > 0) {
                                this.displayExceededContractAlert(exceededPrdList);
                                return;
                            }
                                                    
                            if (this.order.txn_no == "")                            
                                this.transactionService.createTempTxnOrderHeader(this.order, this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId());
                            }

                            if (this.storageService.getSalesInd() == 'S' || this.storageService.getSalesInd() == 'C') {
                                if (!_.isEmpty(this.order)) {
                                    if (this.order.detail.length == 0) {
                                        // check if addQtyList contains any sales_ind = 0
                                        let tempArr = arrPrdWithQty.filter((element, index) => {
                                            return element.line_type.sales_ind == 1;
                                        });

                                        if (tempArr.length > 0) {
                                            if (arrPrdWithQty[0].line_type.sales_ind == 0) {
                                                let index: number = arrPrdWithQty.findIndex((element) => element.line_type.sales_ind == 1);
                                                if (index > -1) {
                                                    let prd = arrPrdWithQty[index];
                                                    arrPrdWithQty.splice(index, 1);
                                                    arrPrdWithQty.splice(0, 0, prd);
                                                } else {
                                                    this.util.displayAlert(this.alertCtrl, "No sales order found", "Please add at least one sales item first!");
                                                    return false;
                                                }
                                            }
                                        } else {
                                            this.util.displayAlert(this.alertCtrl, "No sales order found", "Please add at least one sales item first!");
                                            return false;
                                        }
                                    }
                                } else
                                    this.createNewOrder();
                            }

                            arrPrdWithQty.forEach((product, index) => {
                                this.insertOrderDetail(product);
                            });

                            this.util.displayToast(this.toastCtrl, 'Added ' + arrPrdWithQty.length + ' product(s)');
                            this.storageService.setOrder(this.order).then(() => {
                                this.events.publish('update-order-detail', "start", this.storageService.getToken());
                            })
                            this.resetAll();
                        }
                    else {
                        this.storageService.setSalesInd("");
                        this.storage.remove('selectedCustomer');
                        this.storageService.clearCustomer();
                        this.badgeService.resetBadge();
                        this.storageService.clearOrder();
                        this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.CustomerInvalid.Code, "Customer selected does not belongs to this order type!", Page.CustomerList);
                        return;
                    }
                }
            );
    }

    /**
     * Trigger when user click button add
     * CCLIORDER-1555 force this function to wait until web service calling web service promise revoled or rejected
     * @param p ProductModel product info
     */
    addToOrder(p: ProductModel) { 
        // CCLIORDER-1609
        if (_.isEmpty(this.selectedCustomer) || _.isEmpty(this.selectedCustomer.cust_code)) {
            this.util.displayAlert(this.alertCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message);
            return;
        }

        if (this.util.isFreightFeeSku(p.prd_code, this.storageService.getSettingId())){
            const expectedSku = this.util.getExpectedFreightFeeSku(
                this.selectedCustomer.salesorg.salesorg,
                this.selectedCustomer.salesorg.division
            );
            if (p.prd_code !== expectedSku){
                this.util.displayAlert(this.alertCtrl, "Incorrect Freight Fee SKU",
                    "This Freight Fee SKU does not apply to your sales org/division.");
                return;
            }
            p.quantity = 1;
        }

        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Adding product");
        this.customerService.validateSelectedCustomer(this.selectedCustomer.cust_code, this.storageService.getSalesInd(), this.selectedCustomer.order_reason, this.storageService.getSalesrepCode(), this.storageService.getSettingId())
            .subscribe(
                async (data) => {
                    if (data.length > 0) {
                        if (_.isEmpty(this.selectedCustomer)) {
                            this.util.displayToast(this.toastCtrl, "No customer is selected!");
                            return;
                        }
                        if (!(await this.confirmContractCart())) return;
                        
                        p.line_type = (!p.line_type ? this.lineTypeList[0] : p.line_type);

                        if (!_.isEmpty(this.order)) {
                            if (this.order.detail.length == 0) {
                                if ((p.line_type.sales_ind == 0 && this.storageService.getSalesInd() == "S") || (p.line_type.sales_ind == 0 && this.storageService.getSalesInd() == "C") || (p.line_type.sales_ind == 2 && this.storageService.getSalesInd() == "S") || (p.line_type.sales_ind == 2 && this.storageService.getSalesInd() == "C")) {
                                    this.util.displayAlert(this.alertCtrl, "No sales order found", "Please add at least one sales item first!");
                                    return false;
                                }
                            }
                        } else {
                            this.createNewOrder();
                        }

                        /* Check for not number, negative, zero */
                        if (Number(p.quantity) == NaN)
                            this.util.displayToast(this.toastCtrl, "Please enter number only!");
                        else if (p.quantity < 0)
                            this.util.displayToast(this.toastCtrl, "No negative values are allowed!");
                        // else if (p.quantity == 0 && p.item_cat_grp !="REBATE")
                        else if (p.quantity == 0 && p.line_type.sales_ind != 2)
                            this.util.displayToast(this.toastCtrl, "Please enter value more than 0!");
                        else if (p.quantity % 1 != 0)
                            this.util.displayToast(this.toastCtrl, "No decimal is allowed!");
                        else if (this.getExceededContractProducts([p]).length > 0)
                            this.displayExceededContractAlert([p]);
                        else {
                            if (this.order.txn_no == "") {
                                this.transactionService.createTempTxnOrderHeader(this.order, this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId());
                            }

                            this.insertOrderDetail(p);

                            // CCLIORDER-1555 wait for this job
                            await this.storageService.setOrder(this.order);
                            // CCLIORDER-1555 wait for this job
                            await this.events.publish('update-order-detail', "start", this.storageService.getToken());
                            // CCLIORDER-1555 display message
                            this.util.displayToast(this.toastCtrl, 'Added 1 product');
                        }

                        this.addQtyList = this.addQtyList.filter((element, index) => {
                            return element.prd_code != p.prd_code && element.line_type != p.line_type;
                        });
                        p.quantity = 0;
                        p.line_type = p.line_type_list[0]; //this.lineTypeList[0];
                    } else {
                        this.storageService.setSalesInd("");
                        this.storage.remove('selectedCustomer');
                        this.storageService.clearCustomer();
                        this.badgeService.resetBadge();
                        this.storageService.clearOrder();
                        this.transactionService.deleteTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId()).subscribe();
                        this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.CustomerInvalid.Code, "Customer selected does not belongs to this order type!", Page.CustomerList);
                        return;
                    }
                }
                // on error
                , (error) => {
                    // CCLIORDER-1555 display error message
                    this.util.displayAlert(this.alertCtrl, "Validate error", 'Could not validate the selected customer');
                    this.loading.dismiss();
                }
                // on complete
                , () => {
                    // CCLIORDER-1555 
                    this.loading.dismiss();
                }
            );
    }

    insertOrderDetail(prd: ProductModel) {
        let clonePrd = _.cloneDeep(prd);
        let tempArr = this.order.detail.filter((element, index) => {
            return element.prd_code == clonePrd.prd_code && element.line_type.line_type_code == clonePrd.line_type.line_type_code && element.uom_code == clonePrd.uom;
        });

        if (tempArr.length > 0) {
            tempArr[0].quantity = Number(tempArr[0].quantity) + Number(clonePrd.quantity); /* update tempArr will auto update orderList since its by reference */
            tempArr[0].default_quantity = tempArr[0].quantity; /** 2019.04.24 : WS read value of default_quantity instead of quantity **/
        } else {
            let oDtl = new OrderDetailModel();
            oDtl.prd_code = prd.prd_code;
            oDtl.prd_name = prd.prd_name;

            oDtl.gross_amt = prd.price;

            oDtl.ttl_net_amt = prd.price * prd.quantity;
            oDtl.ttl_gross_amt = prd.price * prd.quantity;
            oDtl.ttl_disc_amt = 0;
            oDtl.ttl_tax_amt = 0;

            oDtl.quantity = prd.quantity;
            oDtl.default_quantity = prd.quantity;
            oDtl.uom_code = prd.uom;
            oDtl.bonus = prd.bonus;
            oDtl.stock_amount = prd.stock_amount.toString();
            oDtl.line_type = prd.line_type;

            if (this.util.isFreightFeeSku(prd.prd_code, this.storageService.getSettingId())) {
                oDtl.item_category = "ZTAD";
                oDtl.line_type = { sales_ind: 1, line_type_code: '', ind: 'S' } as any;
            } else if (prd.item_cat_grp === 'LUMF' || prd.item_cat_grp === 'ERLA') {
                if (this.storageService.getSettingId() === SettingId.TH || this.storageService.getSettingId() === SettingId.TW) {
                    oDtl.item_category = "ZTAI";
                } else if (this.storageService.getSettingId() === SettingId.SG) {
                    oDtl.item_category = "ZTAQ";
                }
            } else {
                oDtl.item_category = "ZTAN";
            }

            let highLevel = new OrderHighLevelModel();
            if (prd.line_type.sales_ind == 0) {
                let salesPrdList = this.order.detail.filter((r) => { return r.line_type.sales_ind == 1; });
                if (salesPrdList.length > 0) {
                    highLevel.prd_code = salesPrdList[salesPrdList.length - 1].prd_code;
                    highLevel.prd_name = salesPrdList[salesPrdList.length - 1].prd_name;
                    highLevel.so_item = salesPrdList[salesPrdList.length - 1].so_item;
                    if (!(Number(highLevel.so_item) > 0)) {
                        let index = this.order.detail.findIndex((r) => { return r.prd_code == highLevel.prd_code && r.line_type.sales_ind == 1 });
                        if (index > -1)
                            highLevel.so_item = (index + 1).toString();
                    }
                }
            }
            oDtl.high_level = highLevel;
            oDtl.base_uom = prd.base_uom; // Base uom CCLIORDER-1876

            if (this.storageService.getSettingId() === SettingId.VN) {
                oDtl.contract_line_no = prd.contract_line_no;
            }

            this.order.detail.push(oDtl);
            this.badgeService.incrementBadge();
        }
    }

    isFreightFeeSku(p: ProductModel): boolean {
        return this.util.isFreightFeeSku(p.prd_code, this.storageService.getSettingId());
    }

    adjustQty(p, status) {
        if (this.isFreightFeeSku(p)) return;

        if (status == "add") { p.quantity++; }
        else if (status == "minus") {
            if (p.quantity > 0) { p.quantity--; }
            else return false;
        }
        // check if exist, if not then add new row
        let tempArr = this.addQtyList.filter((product, index) => {
            return product.prd_code == p.prd_code &&
                product.line_type.line_type_code == p.line_type.line_type_code
        });
        if (tempArr.length > 0)
            tempArr[0] = p;
        else
            this.addQtyList.push(p);
    }

    resetAll() {
        let defaultProductList = _.cloneDeep(this.defaultProductList);
        this.productList = defaultProductList;

        let FOCPrdList = this.productList.filter((r) => { return r.item_cat_grp == 'FOC' }),
            PrdList = this.productList.filter((r) => { return r.item_cat_grp != 'FOC' });
        if (FOCPrdList.length > 0) {
            FOCPrdList.forEach((item) => {
                item.line_type_list = this.FOCLineTypeList;
                // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                if(item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY){
                    item.line_type = this.FOCLineTypeList.find(x => x.line_type_code == "F01") ?? this.FOCLineTypeList[0];
                }
                else {
                    item.line_type = this.FOCLineTypeList[0];
                }
                // FOCPrdList.filter((r) => { r.line_type_list = this.FOCLineTypeList });
            });
        }
        if (PrdList.length > 0) {
            PrdList.forEach((item) => {
                item.line_type_list = this.lineTypeList;
                // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                if(item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY){
                    item.line_type = this.lineTypeList.find(x => x.line_type_code == "F01") ?? this.lineTypeList[0];
                }
                else {
                    item.line_type = this.lineTypeList[0];
                }
            });
        }
        this.addQtyList = [];
        this.util.displayToast(this.toastCtrl, "Reset successfully!");
    }

    reloadPage(refresher) {
        this.oriProductList.length = 0;
        this.retrieveProductList();
        refresher.complete();
    }

    async retrieveProductList(infiniteScroll?: any, searchTerm?: string) {
        if (!navigator.onLine) {
            this.util.displayAlert(this.alertCtrl, Errors.NoInternet.Code, Errors.NoInternet.Message);
            return;
        }

        if (infiniteScroll == undefined) {
            this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
            this.pageIndex = 0; /* Reset back to 0 */
        }

        let salesorg: string = "",
            division: string = "",
            distchannel: string = "",
            soldto_code: string = "",
            shipto_code: string = "";

        if (!_.isEmpty(this.selectedCustomer)) {
            salesorg = this.selectedCustomer.salesorg.salesorg,
            division = this.selectedCustomer.salesorg.division,
            distchannel = this.selectedCustomer.salesorg.distchannel;
            soldto_code = this.selectedCustomer.cust_code;
            shipto_code = this.selectedCustomer.salesorg.shipto_list[0].code;
            if (this.selectedCustomer.payer != undefined && this.selectedCustomer.payer != null) {
                this.material_group_4 = this.selectedCustomer.payer.mat_gr_4;
            }
        }
        searchTerm = (this.searchTerm != "" ? this.searchTerm : "");
        this.productService.retrieveProductList(this.pageIndex, this.storageService.getSalesrepCode(), soldto_code, shipto_code,
            salesorg, division, distchannel, searchTerm.trim(), this.prdGrpCode, this.prdSubGrpCode, this.prdShowBonus, this.prdShowMustSell, this.storageService.getSalesInd(), this.storageService.getSettingId(), this.storageService.getOrderType( this.storageService.getSalesInd()),this.material_group_4, this.isContractOrder ? this.selectedCustomer.selected_contract.contract_no : undefined ).subscribe(
                (data: ProductModel[]) => {
                    this.pageIndex++;
                    let itemsInMobilePage = this.storageService.getItemsInMobilePage();
                    this.util.checkHideFooter(data.length, (this.searchTerm != "" && this.productList.length <= itemsInMobilePage) ? 'down' : this.direction);
                    if (this.storageService.getSettingId() == "1007") {
                        data.forEach(x => {
                            x.price = x.price / 1000;
                        });
                    }

                    if (infiniteScroll == undefined) {
                        this.productList = data;
                        this.defaultProductList = _.cloneDeep(data);

                        if (data.length > 0) {
                            this.retrieveProductLineTypeList();
                            if (this.storageService.getSettingId() === this.SettingIdEnum.MY) {
                                this.getBatchNumberExipryDate(data);
                            }

                            if(this.storageService.getSettingId() === this.SettingIdEnum.VN) {
                                this.getProductVisaExipryDate(data); // EO-3457 - VN Display VISA and Batch
                            }
                        }

                        // EO-3513 - TW Freight Fee SKU: default quantity to 1 for display
                        this.productList.forEach((item) => {
                            if (this.util.isFreightFeeSku(item.prd_code, this.storageService.getSettingId())) {
                                item.quantity = 1;
                            }
                        });
                    } else {
                        infiniteScroll.complete();

                        let FOCPrdList = data.filter((r) => { return r.item_cat_grp == 'FOC' }),
                            PrdList = data.filter((r) => { return r.item_cat_grp != 'FOC' });
                        if (FOCPrdList.length > 0) {
                            FOCPrdList.forEach((item) => {
                                item.line_type_list = this.FOCLineTypeList;
                                // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                                if (item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY) {
                                    item.line_type = this.FOCLineTypeList.find(x => x.line_type_code == "F01") ?? this.FOCLineTypeList[0];
                                } else {
                                    item.line_type = this.FOCLineTypeList[0];
                                }
                            });
                        }
                        if (PrdList.length > 0) {
                            PrdList.forEach((item) => {
                                item.line_type_list = this.lineTypeList;
                                // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                                if (item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY) {
                                    item.line_type = this.lineTypeList.find(x => x.line_type_code == "F01") ?? this.lineTypeList[0];
                                } else {
                                    item.line_type = this.lineTypeList[0];
                                }
                            });
                        }

                        if (this.storageService.getSettingId() === this.SettingIdEnum.MY) {
                            this.getBatchNumberExipryDate(data);
                        }

                        if(this.storageService.getSettingId() === this.SettingIdEnum.VN) {
                            this.getProductVisaExipryDate(data); // EO-3457 - VN Display VISA and Batch
                        }

                        this.productList = this.productList.concat(data);
                        this.defaultProductList = this.defaultProductList.concat(_.cloneDeep(data));

                        // EO-3513 - TW Freight Fee SKU: default quantity to 1 for display
                        this.productList.forEach((item) => {
                            if (this.util.isFreightFeeSku(item.prd_code, this.storageService.getSettingId())) {
                                item.quantity = 1;
                            }
                        });
                    }
                },
                (err) => {
                    if (infiniteScroll !== undefined) {
                        infiniteScroll.complete();
                    }
                    this.util.processError(this.loading, this.alertCtrl, err);
                },
                () => {
                    if (infiniteScroll == undefined) {
                        this.loading.dismiss();
                    }
                });
    }

    retrieveProductLineTypeList() {
        this.productService.retrieveLineTypeList(this.storageService.getSettingId(), this.storageService.getSalesInd()).subscribe(
            (data) => {
                this.lineTypeList = data;
                this.FOCLineTypeList = _.cloneDeep(data);
                this.FOCLineTypeList = this.FOCLineTypeList.filter((r) => { return r.sales_ind == 0 });

                this.RebateLineTypeList = _.cloneDeep(data);
                this.RebateLineTypeList = this.RebateLineTypeList.filter((r) => { return r.sales_ind == 2});


                let FOCPrdList = this.productList.filter((r) => { return r.item_cat_grp == 'FOC' }),
                    PrdList = this.productList.filter((r) => { return r.item_cat_grp != 'FOC' }),
                    RebatePrdList = this.productList.filter((r)=>{return r.item_cat_grp == 'REBATE'});

                if (FOCPrdList.length > 0) {
                    FOCPrdList.forEach((item) => {
                        item.line_type_list = this.FOCLineTypeList;
                        // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                        if(item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY){
                            item.line_type = this.FOCLineTypeList.find(x => x.line_type_code == "F01") ?? this.FOCLineTypeList[0];
                        }
                        else {
                            item.line_type = this.FOCLineTypeList[0];
                        }
                    });
                }
                if (PrdList.length > 0) {
                    PrdList.forEach((item) => {
                        item.line_type_list = this.lineTypeList;
                        if(item.item_cat_grp=='REBATE'){
                            item.line_type = this.lineTypeList[2];
                        }
                        // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                        else if(item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY){
                            item.line_type = this.lineTypeList.find(x => x.line_type_code == "F01") ?? this.lineTypeList[0];
                        }
                        else {
                            item.line_type = this.lineTypeList[0];
                        }
                    });
                }
                if (RebatePrdList.length > 0) {
                    RebatePrdList.forEach((item)=>{
                        item.line_type_list = this.RebateLineTypeList;
                        // CCLIORDER-3081 - [MY] Request to Set SKU Types to F01 by Default
                        if(item.prd_code.startsWith("200") && this.storageService.getSettingId() == SettingId.MY){
                            item.line_type = this.RebateLineTypeList.find(x => x.line_type_code == "F01") ?? this.RebateLineTypeList[0];
                        }
                        else {
                            item.line_type = this.RebateLineTypeList[0];
                        }
                    })
                }
            },
            (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
            },
            () => {
                //
            }
        );
    }

    viewFilterOpt(event: any) {
        let popOver = this.popoverCtrl.create('ProductFilterPopover', { prdGrpCode: this.prdGrpCode, prdSubGrpCode: this.prdSubGrpCode, prdShowBonus: this.prdShowBonus, prdShowMustSell: this.prdShowMustSell });
        popOver.present({ ev: event });
        popOver.onDidDismiss((data) => {
            if (data) {
                this.prdGrpCode = data.prdGrpCode;
                this.prdSubGrpCode = data.prdSubGrpCode;
                this.prdShowBonus = data.prdShowBonus;
                this.prdShowMustSell = data.prdShowMustSell;
                this.retrieveProductList(undefined, "");
            }
        })
    }

    gotoPrevTab(e) {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.CustomerList);
    }
    
    gotoNextTab(e) {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.OrderList);
    }

    scrollToTop() {
        this.content.scrollToTop();
    }

    populateBottomPixel() {
        if (this.platform.is('mobile') == true) {
            this.bottomPixel = (80 + this.elementView.nativeElement.offsetHeight) + 'px';
        } else {
            this.bottomPixel = (20 + this.elementView.nativeElement.offsetHeight) + 'px';
        }
        this.content.ionScrollEnd.subscribe((data) => {
            if(data == null){
                this.showScrollToTop = false;
            }
            else{
                let itemsInMobilePage = this.storageService.getItemsInMobilePage();
                if (data['scrollTop'] > 0) { this.showScrollToTop = true; }
                else { this.showScrollToTop = false; }
                if(this.productList.length <= itemsInMobilePage) {this.util.checkHideFooter(this.productList.length, '')}
                else if (data['directionY'] == "up") { this.util.checkHideFooter(10, data['directionY']) }
                this.direction = data['directionY'];
            }
            this.changeDetectorRef.detectChanges();
        });
    }

    /***
     * Open bom selection modal
     */
    selectBom(item: ProductModel) {
        // Prevent other countries to access bom feature
        if (this.storageService.getSettingId() !== SettingId.TH && this.storageService.getSettingId() !== SettingId.SG && this.storageService.getSettingId() !== SettingId.TW) {
            return;
        }

        if (_.isEmpty(this.selectedCustomer)) {
            this.util.displayAlert(this.alertCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message);
            return;
        }

        let bomModal = this.modalCtrl.create('BomProductSelectionPage', { product: item }, { enableBackdropDismiss: false, cssClass: 'page-bom-product-selection' });
        bomModal.present();
        bomModal.onDidDismiss((data) => {
            if (!!data) {
                if (!!data.action) {
                    switch (data.action) {
                        case ModalAction.Cancel:
                          return false;
                        case ModalAction.Proceed:
                            // this.addBomnToOrder(data.lstBomProduct);
                            this.addToOrder(data.product);
                            return;
                    }
                } 
            } 
        });
    }

    checkProductType(item: ProductModel) {
        // Check product type
        if (item.item_cat_grp === 'LUMF' || item.item_cat_grp === 'ERLA') {
            return this.ProductTypeEnum.BOM;
        } else {
            return this.ProductTypeEnum.NORMAL;
        }
    }

    isBomProductAvailable() {
        let setting_id = this.storageService.getSettingId();
        let sales_ind = this.storageService.getSalesInd();
        // Check product type
        if (sales_ind === this.SalesIndEnum.NORMAL && (setting_id === this.SettingIdEnum.TH || setting_id === this.SettingIdEnum.SG || setting_id === this.SettingIdEnum.TW) && this.storageService.getSetupValue(this.setups.AllowBom.ID) === '1') {
            return true;
        } else {
            return false;
        }
    }

    viewCustomerCrm(event: any) {
        if (this.customerService.isShowingCustomerCrm(this.storageService.getSettingId())) {
            let _data = new CustomerCrmModel();
            _data.CrmTxt = this.customerCrmContent;
            _data.CustomerCode = this.selectedCustomer.cust_code;
            _data.CustomerName = this.selectedCustomer.cust_name;
            _data.SalesOrg = this.selectedCustomer.salesorg.salesorg;
            _data.DistChannel = this.selectedCustomer.salesorg.distchannel;
            _data.Division = this.selectedCustomer.salesorg.division;

            let CustomerCrmPage = this.modalCtrl.create('CustomerCrmPage', { data: _data }, { enableBackdropDismiss: false });
            CustomerCrmPage.present();
        }
    }

    private getBatchNumberExipryDate(_data: ProductModel[]) {
        this.productService.getProductExipryDate(_data.map(r => r.prd_code), this.storageService.getSettingId()).subscribe(
            (res) => {
                for (let index = 0; index < _data.length; index++) {
                    let temp = res.data.find(r => r.prd_code === _data[index].prd_code);

                    if (temp) {
                        _data[index].expiry_date = this.formatDate(temp.expiry_date);
                        if (this.isAboutToExpire(temp.expiry_date)) {
                            _data[index].isDisplayWarningExpiryDate = true
                        } else {
                            _data[index].isDisplayWarningExpiryDate = false
                        }
                    } else {
                        _data[index].expiry_date = null;
                        _data[index].isDisplayWarningExpiryDate = false;
                    }
                }
            }
        );
    }

    private isAboutToExpire(expiryDate) {
        const today = new Date();
        const expire = new Date(expiryDate);

        const sixMonthsFromNow = new Date(today);
        sixMonthsFromNow.setMonth(today.getMonth() + 6);

        return expire <= sixMonthsFromNow;
    }

    private formatDate(str) {
        const [m, d, y] = str.split('/');
        const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return `${d} ${months[m - 1]} ${y}`;
    }

    // EO-3457 - VN Display VISA and Batch
    private getProductVisaExipryDate(_data: ProductModel[]) {
        const requestedCodes = _data.map(r => r.prd_code);

        this.productService.getProductVisaExipryDate(requestedCodes, this.storageService.getSettingId()).subscribe(
            (res) => {
                const targets: ProductModel[][] = [_data, this.productList, this.defaultProductList];

                targets.forEach((list) => {
                    list.forEach((prd) => {
                        if (requestedCodes.indexOf(prd.prd_code) === -1) { return; }
                        const temp = res.data.find(r => r.prd_code === prd.prd_code);
                        this.applyVisaBatchInfo(prd, temp);
                    });
                });
            }
        );
    }

    private applyVisaBatchInfo(prd: ProductModel, temp: any) {
        if (temp) {
            prd.batch_no = temp.batch_no;
            prd.visa_no = temp.visa_number;

            if (this.hasValidExpiryDate(temp.batch_expiry_date)) {
                const expDate = this.parseDdMmYy(temp.batch_expiry_date);
                prd.expiry_date = this.formatDateObj(expDate);
                prd.isDisplayWarningExpiryDate = this.isAboutToExpire(expDate);
            } else {
                prd.expiry_date = null;
                prd.isDisplayWarningExpiryDate = false;
            }
        } else {
            prd.expiry_date = null;
            prd.isDisplayWarningExpiryDate = false;
            prd.batch_no = null;
            prd.visa_no = null;
        }
    }

    private hasValidExpiryDate(str: string): boolean {
        if (!str || !str.trim()) { return false; }
        const parts = str.trim().split('/').map(Number);
        if (parts.length !== 3 || parts.some(isNaN)) { return false; }
        const [d, m, y] = parts;
        return d > 0 && m > 0 && y > 0;
    }

    private parseDdMmYy(str: string): Date {
        const [d, m, y] = str.split('/').map(Number);
        return new Date(y < 100 ? 2000 + y : y, m - 1, d);
    }

    private formatDateObj(dt: Date): string {
        const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return `${('0' + dt.getDate()).slice(-2)} ${months[dt.getMonth()]} ${dt.getFullYear()}`;
    }

    /**
     * Create / edit order 
     * @param lstBomProduct BomProductModel
     */
    // private addBomnToOrder(lstBomProduct: BomProductModel[]) {
    //     this.customerService.validateSelectedCustomer(this.storageService.getToken()
    //     , this.selectedCustomer.cust_code
    //     , this.storageService.getSalesInd()
    //     , this.selectedCustomer.order_reason
    //     , this.storageService.getSalesrepCode()
    //     , this.storageService.getSettingId())
    //     .subscribe(
    //         (data) => {
    //             if (data.length > 0) {
    //                 let arrPrdWithQty: ProductModel[] = [];
    //                 lstBomProduct.forEach((item, index) =>{
    //                     if (item.quantity > 0) {
    //                         let product: ProductModel = {
    //                             prd_grp_code: '',
    //                             prd_grp_name: '',
    //                             uom_list: [],
    //                             must_sell: undefined,
    //                             line_type: item.line_type,
    //                             line_type_list: [],
    //                             item_cat_grp: item.item_cat_grp,
    //                             base_uom: item.uom,
    //                             prd_code: item.prd_code,
    //                             prd_name: item.prd_name,
    //                             uom: item.uom,
    //                             price: item.price,
    //                             quantity: item.quantity,
    //                             stock_amount: item.stock_amount,
    //                             bonus: item.bonus,
    //                             tax: item.tax,
    //                             line_type_code: '', //item.line_type_code,
    //                             total: 0,
    //                             prd_type: item.isParent ? ProductType.Bom : ProductType.ChildBom,
    //                         }
    //                         arrPrdWithQty.push(product);
    //                     }
    //                 });

    //                 if (arrPrdWithQty.length > 0) {
    //                     if (this.order.txn_no === "") {
    //                         this.transactionService.createTempTxnOrderHeader(this.order, this.storageService.getToken(), this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId());
    //                     }
                            
    //                     if (this.storageService.getSalesInd() === 'S' || this.storageService.getSalesInd() === 'C') {
    //                         if (!_.isEmpty(this.order)) {
    //                             if (this.order.detail.length == 0) {
    //                                 // check if addQtyList contains any sales_ind = 1
    //                                 let tempArr = arrPrdWithQty.filter((element, index) => {
    //                                     return element.line_type.sales_ind == 1;
    //                                 });

    //                                 if (tempArr.length > 0) {
    //                                     if (arrPrdWithQty[0].line_type.sales_ind == 0) {
    //                                         let index: number = arrPrdWithQty.findIndex((element) => element.line_type.sales_ind == 1);
    //                                         if (index > -1) {
    //                                             let prd = arrPrdWithQty[index];
    //                                             arrPrdWithQty.splice(index, 1);
    //                                             arrPrdWithQty.splice(0, 0, prd);
    //                                         } else {
    //                                             this.util.displayAlert(this.alertCtrl, "No sales order found", "Please add at least one sales item first!");
    //                                             return false;
    //                                         }
    //                                     }
    //                                 } else {
    //                                     this.util.displayAlert(this.alertCtrl, "No sales order found", "Please add at least one sales item first!");
    //                                     return false;
    //                                 }
    //                             }
    //                         } else {
    //                             this.createNewOrder();
    //                         }
    //                     }

    //                     let uid = this.util.generateGUID();
    //                     this.insertBomIntoOrderDetail(arrPrdWithQty, uid);

    //                     this.util.displayToast(this.toastCtrl, 'Bom package has been added.');
    //                     this.storageService.setOrder(this.order).then(() => {
    //                         this.events.publish('update-order-detail', "start", this.storageService.getToken());
    //                     });
    //                 };
    //             } else {
    //                 this.storageService.setSalesInd("");
    //                 this.storage.remove('selectedCustomer');
    //                 this.storageService.clearCustomer();
    //                 this.badgeService.resetBadge();
    //                 this.storageService.clearOrder();
    //                 this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.CustomerInvalid.Code, "Customer selected does not belongs to this order type!", Page.CustomerList);
    //                 return;
    //             }
    //         }
    //     );
    // }

    /**
     * Insert a bom package into order detail
     * @param prd ProductModel
     */
    // private insertBomIntoOrderDetail(lstPrd: ProductModel[], uid: string) {
    //     let lastIndexOfBomPackage = lstPrd.length + this.order.detail.length - 1;
    //     lstPrd.forEach((prd, index) => {
    //         let oDtl = new OrderDetailModel();
    //         oDtl.prd_code = prd.prd_code;
    //         oDtl.prd_name = prd.prd_name;
    
    //         oDtl.gross_amt = prd.price;
    
    //         oDtl.ttl_net_amt = prd.price * prd.quantity;
    //         oDtl.ttl_gross_amt = prd.price * prd.quantity;
    //         oDtl.ttl_disc_amt = 0;
    //         oDtl.ttl_tax_amt = 0;
    
    //         oDtl.quantity = prd.quantity;
    //         oDtl.default_quantity = prd.quantity;
    //         oDtl.uom_code = prd.uom;
    //         oDtl.bonus = prd.bonus;
    //         oDtl.stock_amount = prd.stock_amount.toString();
    //         oDtl.line_type = prd.line_type;
    //         oDtl.item_category = this.util.generateItemCategoryForBomProduct(prd.prd_type === ProductType.Bom ? true: false, this.storageService.getSettingId());
    
    //         let highLevel = new OrderHighLevelModel();

    //         if (prd.prd_type === ProductType.ChildBom) {
    //             let salesPrdList = this.order.detail.filter((r) => { return r.packageBomUID === uid && r.prd_type === ProductType.Bom });
                
    //             highLevel.prd_code = salesPrdList[salesPrdList.length - 1].prd_code;
    //             highLevel.prd_name = salesPrdList[salesPrdList.length - 1].prd_name;
    //             highLevel.so_item = salesPrdList[salesPrdList.length - 1].so_item;

    //             if (!(Number(highLevel.so_item) > 0)) {
    //                 let index = this.order.detail.findIndex((r) => { return r.packageBomUID === uid && r.prd_type === ProductType.Bom });
    //                 if (index > -1)
    //                     highLevel.so_item = (index + 1).toString();
    //             }
    //         }

    //         oDtl.high_level = highLevel;
    //         oDtl.base_uom = prd.base_uom; // Base uom CCLIORDER-1876
    
    //         // prd_type
    //         oDtl.prd_type = prd.prd_type;
    //         oDtl.isParentBom = prd.prd_type === ProductType.Bom ? true : false;
    //         oDtl.isChildBom = prd.prd_type === ProductType.Bom ? false : true;
    //         oDtl.packageBomUID = uid
    //         oDtl.lastIndexOfBomPackage = lastIndexOfBomPackage;
    
    //         this.order.detail.push(oDtl);
    //         this.badgeService.incrementBadge();
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/pages/product/product.ts